var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellAlt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.69992 9.3C5.69992 5.82061 8.52053 3 11.9999 3C15.4793 3 18.2999 5.82061 18.2999 9.3V12.8394C18.2999 13.6012 18.4894 14.3509 18.8514 15.0212L19.4068 16.0497C20.1263 17.3822 19.1614 19 17.647 19H11.9999H6.35289C4.83849 19 3.87352 17.3822 4.59308 16.0497L5.14848 15.0212C5.51042 14.3509 5.69992 13.6012 5.69992 12.8394V9.3Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.87744 20.5C9.6105 21.4145 10.7369 22 12.0001 22C13.2633 22 14.3898 21.4145 15.1228 20.5H8.87744Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 3C13 2.44772 12.5523 2 12 2C11.4477 2 11 2.44772 11 3V4C11 4.55228 11.4477 5 12 5C12.5523 5 13 4.55228 13 4V3Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellAlt1);
export default __webpack_public_path__ + "static/media/bell-alt-1.723708c9aca0a7014bcaac5786709fa5.svg";
export { ForwardRef as ReactComponent };